import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import {RootState, store} from "./store";
import {CustomerSliceState} from "./slices/customerSlice";
import {createSelector} from "@reduxjs/toolkit";
import {WishlistSliceState} from "./slices/wishlishSlice";

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

// store selector
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// memoized customer selector
const customerSelector = createSelector([(state: RootState) => state.customer], (customer) => customer);
export const useCustomerSelector = (): CustomerSliceState => useAppSelector(customerSelector);

// memoized wishlist selector
const wishlistSelector = createSelector([(state: RootState) => state.wishlist], (wishlist) => wishlist);
export const useWishlistSelector = (): WishlistSliceState => useAppSelector(wishlistSelector);
